import { User } from "oidc-client-ts";
import { useDotNetController } from "../useDotNetController/useDotNetController";

export const useClientAppController = <T,>(
  user?: User,
  cacheResponse: boolean = true
) => {
  return useDotNetController<T>("ClientApp", user, cacheResponse);
};
